import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-01748620"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "out-num"
};
const _hoisted_2 = {
  class: "num-con"
};
const _hoisted_3 = {
  class: "num"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  class: "desc"
};
const _hoisted_6 = {
  class: "line"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, "0" + _toDisplayString($props.index + 1) + ".", 1), _createElementVNode("div", _hoisted_4, _toDisplayString($props.info.title), 1), _createElementVNode("div", _hoisted_5, _toDisplayString($props.info.desc), 1)]), _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [[_vShow, ($props.index + 1) % 3 !== 0]])]);
}